// Translations
export const translations = {
  en: {
    title: "PLANE-1513",
    subtitle: "Tactical Strike System",
    mission: "MISSION",
    missionDesc: "Locate and destroy the enemy aircraft prototype (1-5-1-3). Striking the Head destroys the unit.",
    level: "Level",
    clicks: "Clicks",
    score: "Score",
    targetIntel: "TARGET INTEL",
    statusLog: "STATUS LOG",
    miss: "MISS",
    hurt: "HURT",
    boom: "BOOM",
    winTitle: "SECTOR CLEARED",
    loseTitle: "MISSION FAILED",
    winDesc: "Target neutralized. Airspace secure.",
    loseDesc: "Target lost. Reinforcements required.",
    nextLevel: "PASS - NEXT LEVEL",
    retry: "FAIL - RETRY",
    toBeContinued: "To be continued...",
    awaitingInput: "Awaiting coordinate input...",
    sector: "SEC",
    passScore: "Pass Score",
    yourScore: "Your Score",
    idealClicks: "Par",
  },
  zh: {
    title: "代号-1513",
    subtitle: "战术打击系统",
    mission: "任务",
    missionDesc: "定位并摧毁敌方原型机 (1-5-1-3)。击中机头可直接摧毁目标。",
    level: "关卡",
    clicks: "步数",
    score: "得分",
    targetIntel: "目标情报",
    statusLog: "战况日志",
    miss: "未中",
    hurt: "击中",
    boom: "摧毁",
    winTitle: "区域肃清",
    loseTitle: "任务失败",
    winDesc: "目标已瘫痪。空域安全。",
    loseDesc: "目标丢失。请求增援。",
    nextLevel: "通过 - 下一关",
    retry: "失败 - 重试",
    toBeContinued: "未完待续...",
    awaitingInput: "等待坐标输入...",
    sector: "区域",
    passScore: "及格分",
    yourScore: "你的得分",
    idealClicks: "标准步数",
  },
  ja: {
    title: "プレーン-1513",
    subtitle: "戦術打撃システム",
    mission: "任務",
    missionDesc: "敵のプロトタイプ機 (1-5-1-3) を特定し破壊せよ。機首への打撃で撃破可能。",
    level: "レベル",
    clicks: "手数",
    score: "スコア",
    targetIntel: "標的情報",
    statusLog: "ステータスログ",
    miss: "ミス",
    hurt: "命中",
    boom: "撃破",
    winTitle: "セクタークリア",
    loseTitle: "任務失敗",
    winDesc: "ターゲット無力化。空域の安全確保。",
    loseDesc: "ターゲット喪失。増援を要請する。",
    nextLevel: "合格 - 次のレベルへ",
    retry: "失敗 - 再試行",
    toBeContinued: "つづく...",
    awaitingInput: "座標入力待機中...",
    sector: "区画",
    passScore: "合格点",
    yourScore: "スコア",
    idealClicks: "基準手数",
  },
  fr: {
    title: "AVION-1513",
    subtitle: "Système de Frappe Tactique",
    mission: "MISSION",
    missionDesc: "Localiser et détruire le prototype ennemi (1-5-1-3). Frapper la tête détruit l'unité.",
    level: "Niveau",
    clicks: "Clics",
    score: "Score",
    targetIntel: "RENSEIGNEMENTS",
    statusLog: "JOURNAL",
    miss: "RATÉ",
    hurt: "TOUCHÉ",
    boom: "BOOM",
    winTitle: "SECTEUR SÉCURISÉ",
    loseTitle: "ÉCHEC MISSION",
    winDesc: "Cible neutralisée.",
    loseDesc: "Cible perdue.",
    nextLevel: "RÉUSSI - SUIVANT",
    retry: "ÉCHEC - RÉESSAYER",
    toBeContinued: "À suivre...",
    awaitingInput: "En attente de coordonnées...",
    sector: "SEC",
    passScore: "Score Requis",
    yourScore: "Votre Score",
    idealClicks: "Par",
  },
  es: {
    title: "AVIÓN-1513",
    subtitle: "Sistema Táctico",
    mission: "MISIÓN",
    missionDesc: "Localizar y destruir el prototipo enemigo (1-5-1-3). Golpear la cabeza destruye la unidad.",
    level: "Nivel",
    clicks: "Clics",
    score: "Puntuación",
    targetIntel: "INTELIGENCIA",
    statusLog: "REGISTRO",
    miss: "FALLO",
    hurt: "IMPACTO",
    boom: "BOOM",
    winTitle: "SECTOR DESPEJADO",
    loseTitle: "MISIÓN FALLIDA",
    winDesc: "Objetivo neutralizado.",
    loseDesc: "Objetivo perdido.",
    nextLevel: "PASAR - SIGUIENTE",
    retry: "FALLO - REINTENTAR",
    toBeContinued: "Continuará...",
    awaitingInput: "Esperando coordenadas...",
    sector: "SEC",
    passScore: "Puntaje Pase",
    yourScore: "Tu Puntaje",
    idealClicks: "Par",
  },
  ru: {
    title: "САМОЛЕТ-1513",
    subtitle: "Тактическая Система",
    mission: "МИССИЯ",
    missionDesc: "Найти и уничтожить прототип (1-5-1-3). Удар в голову уничтожает цель.",
    level: "Уровень",
    clicks: "Ходы",
    score: "Счет",
    targetIntel: "РАЗВЕДКА",
    statusLog: "ЖУРНАЛ",
    miss: "МИМО",
    hurt: "ПОПАЛ",
    boom: "БУМ",
    winTitle: "СЕКТОР ЗАЧИЩЕН",
    loseTitle: "ПРОВАЛ МИССИИ",
    winDesc: "Цель нейтрализована.",
    loseDesc: "Цель потеряна.",
    nextLevel: "ПРОЙТИ - ДАЛЕЕ",
    retry: "ПРОВАЛ - ЗАНОВО",
    toBeContinued: "Продолжение следует...",
    awaitingInput: "Ожидание координат...",
    sector: "СЕК",
    passScore: "Проходной балл",
    yourScore: "Ваш счет",
    idealClicks: "Норма",
  },
  pt: {
    title: "AVIÃO-1513",
    subtitle: "Sistema Tático",
    mission: "MISSÃO",
    missionDesc: "Localizar e destruir o protótipo inimigo (1-5-1-3). Atingir a cabeça destrói a unidade.",
    level: "Nível",
    clicks: "Cliques",
    score: "Pontuação",
    targetIntel: "INTELIGÊNCIA",
    statusLog: "REGISTRO",
    miss: "ERROU",
    hurt: "ACERTOU",
    boom: "BOOM",
    winTitle: "SETOR LIMPO",
    loseTitle: "MISSÃO FALHOU",
    winDesc: "Alvo neutralizado.",
    loseDesc: "Alvo perdido.",
    nextLevel: "PASSAR - PRÓXIMO",
    retry: "FALHA - TENTAR NOVAMENTE",
    toBeContinued: "Continua...",
    awaitingInput: "Aguardando coordenadas...",
    sector: "SEC",
    passScore: "Nota de Corte",
    yourScore: "Sua Nota",
    idealClicks: "Par",
  },
  ko: {
    title: "비행기-1513",
    subtitle: "전술 타격 시스템",
    mission: "임무",
    missionDesc: "적의 프로토타입(1-5-1-3)을 찾아 파괴하십시오. 머리를 타격하면 파괴됩니다.",
    level: "레벨",
    clicks: "클릭 수",
    score: "점수",
    targetIntel: "표적 정보",
    statusLog: "상태 로그",
    miss: "빗나감",
    hurt: "타격",
    boom: "파괴",
    winTitle: "구역 확보",
    loseTitle: "임무 실패",
    winDesc: "표적 무력화 완료.",
    loseDesc: "표적 상실. 지원 요청.",
    nextLevel: "통과 - 다음 레벨",
    retry: "실패 - 다시 시도",
    toBeContinued: "계속됩니다...",
    awaitingInput: "좌표 입력 대기 중...",
    sector: "구역",
    passScore: "합격 점수",
    yourScore: "당신의 점수",
    idealClicks: "기준",
  },
  ar: {
    title: "طائرة-1513",
    subtitle: "نظام الضربة التكتيكية",
    mission: "مهمة",
    missionDesc: "حدد موقع الطائرة النموذجية للعدو (1-5-1-3) ودمرها. ضرب الرأس يدمر الوحدة.",
    level: "مستوى",
    clicks: "نقرات",
    score: "نتيجة",
    targetIntel: "استخبارات الهدف",
    statusLog: "سجل الحالة",
    miss: "خطأ",
    hurt: "إصابة",
    boom: "تدمير",
    winTitle: "تم تأمين القطاع",
    loseTitle: "فشلت المهمة",
    winDesc: "تم تحييد الهدف.",
    loseDesc: "فقد الهدف.",
    nextLevel: "نجاح - التالي",
    retry: "فشل - إعادة المحاولة",
    toBeContinued: "يتبع...",
    awaitingInput: "في انتظار الإحداثيات...",
    sector: "قطاع",
    passScore: "درجة النجاح",
    yourScore: "درجتك",
    idealClicks: "المثالي",
  },
  hi: {
    title: "विमान-1513",
    subtitle: "सामरिक हमला प्रणाली",
    mission: "मिशन",
    missionDesc: "दुश्मन के विमान (1-5-1-3) को खोजें और नष्ट करें। सिर पर मारने से इकाई नष्ट हो जाती है।",
    level: "स्तर",
    clicks: "क्लिक",
    score: "स्कोर",
    targetIntel: "लक्ष्य खुफिया",
    statusLog: "स्थिति लॉग",
    miss: "चूक",
    hurt: "चोट",
    boom: "विस्फोट",
    winTitle: "सेक्टर साफ",
    loseTitle: "मिशन विफल",
    winDesc: "लक्ष्य बेअसर।",
    loseDesc: "लक्ष्य खो गया।",
    nextLevel: "पास - अगला स्तर",
    retry: "विफल - पुनः प्रयास करें",
    toBeContinued: "जारी रहेगा...",
    awaitingInput: "निर्देशांक इनपुट की प्रतीक्षा है...",
    sector: "सेक्टर",
    passScore: "पास स्कोर",
    yourScore: "आपका स्कोर",
    idealClicks: "आदर्श",
  }
};

export const getTranslation = (lang) => {
  const shortLang = lang.split('-')[0];
  return translations[shortLang] || translations.en;
};
